import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "src/assets/imports/antdComponents";
import ZSLogo from "public/img/AskKural.svg?url";
import { RootState } from "src/store";
import { getExecutiveSummaryData } from "src/pages/Insights/serviceHelper";
import { setError, setExecutiveSummaryData, setLoading } from "src/pages/Insights/states/executiveSummarySlice";

function processData(originalData) {
	const productMasterData = {};
	const newWavess = [];

	// Extract product names from the first wave
	const productNames = Object.keys(originalData.chartData[0]).filter((key) => key !== "name");

	productNames.forEach((productName) => {
		productMasterData[productName] = {
			color: originalData.colorLegends[productName],
			textColor: originalData.colorLegends[productName],
			waves: [],
		};
	});

	originalData.chartData.forEach((wave, index) => {
		const waveObj = {
			wave: wave.name,
			metrics: {
				awareness: {},
				familiarity: {},
				trials: {},
				usage: {},
			},
			sampleSize: originalData.n_size_value[index] || `n = ${60 + index * 5} - ${65 + index * 5}`,
		};

		productNames.forEach((productName) => {
			// Convert decimal to percentage and round to nearest integer
			const value = Math.round(wave[productName] * 100);

			productMasterData[productName].waves.push({
				awareness: value,
				familiarity: value,
				trials: value,
				usage: value,
			});

			waveObj.metrics.awareness[productName] = value;
			waveObj.metrics.familiarity[productName] = value;
			waveObj.metrics.trials[productName] = value;
			waveObj.metrics.usage[productName] = value;
		});

		newWavess.push(waveObj);
	});

	return { productMasterData, newWavess };
}

const CustomeMetrics = ({ data }) => {
	const { productMasterData, newWavess } = processData(data);
	const [hindSelect, setHideSelect] = useState(true);
	const availableProducts = Object.keys(productMasterData).map((name) => ({
		name,
		...productMasterData[name],
	}));

	const [selectedProducts, setSelectedProducts] = useState(availableProducts.slice(0, 2));

	const [waves, setWaves] = useState([]);

	const { Option } = Select;

	const metrics = [
		{ label: "Awareness", baseValue: "05%" },
		{ label: "Familiarity", baseValue: "10%" },
		{ label: "Trials", baseValue: "05%" },
		{ label: "Usage", baseValue: "05%" },
	];

	useEffect(() => {
		const newWaves = newWavess;

		newWaves.forEach((wave, index) => {
			wave.metrics = {
				awareness: {},
				familiarity: {},
				trials: {},
				usage: {},
			};
			selectedProducts.forEach((product) => {
				Object.keys(wave.metrics).forEach((metric) => {
					wave.metrics[metric][product.name] = productMasterData[product.name].waves[index][metric.toLowerCase()];
				});
			});
		});
		const arr = [newWaves[0]];
		setWaves([...arr, ...newWaves]);
	}, [selectedProducts]);

	const maxWidth = Math.max(...availableProducts.map((p) => p.name.length * 10), 150); // Adjust multiplier as needed

	return (
		<div className="h-full z-1">
			<div className="w-full px-6 ">
				<div className="flex items-center justify-center gap-4 p-2 mb-6">
					{selectedProducts.map((product) => (
						<div className="flex items-center" key={product.name}>
							<div className={`w-3 h-5 rounded-full ${product.color || "bg-red"} mr-2`} style={{ backgroundColor: product.color }} />
							<span className="text-gray-600 mr-4 text-[10px]">{product.name}</span>
						</div>
					))}
					<div className="mb-0">
						{hindSelect && (
							<span className="-ml-6" style={{ transform: "scale(0.5) rotate(90deg)", display: "inline-block" }}>
								<i
									className="material-symbols-outlined"
									tabIndex={0}
									role="button"
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											e.preventDefault();
											setHideSelect(false);
										}
									}}
									onClick={() => setHideSelect(false)}>
									chevron_forward
								</i>
							</span>
						)}
						{!hindSelect && (
							<Select
								mode="multiple"
								placeholder="Select products"
								value={selectedProducts.map((product) => product.name)}
								tagRender={() => null} // This hides selected values beside the dropdown
								onChange={(selectedValues) => {
									const newSelectedProducts = selectedValues.map((value) => availableProducts.find((product) => product.name === value));
									setSelectedProducts(newSelectedProducts);
								}}
								onBlur={() => setHideSelect(true)}
								className="ant-select-custom" // Add a custom class for additional styling if needed
								onMouseEnter={(e) => (e.currentTarget.style.width = `${maxWidth}px`)} // Expand on hover
								onMouseLeave={(e) => (e.currentTarget.style.width = "30px")} // Reset on leave
								style={{ boxShadow: "none", border: "none", background: "transparent" }}>
								{availableProducts.map((product) => (
									<Option key={product.name} value={product.name}>
										{product.name}
									</Option>
								))}
							</Select>
						)}
					</div>
				</div>

				<div className="grid grid-cols-[10%_repeat(auto-fit,minmax(0,1fr))]">
					{/* Labels Column */}
					{/* <div className="flex flex-col flex-1 p-6 ">
						<div className="space-y-10 ">
							{metrics.map((metric, i) => (
								<div
									key={metric.label}
									className="flex  mt-16 justify-between h-auto bo text-center"
									style={{ height: `${selectedProducts?.length * 1.5 || 0}rem` }}>
									<div className="text-base-1 font-semibold text-[--secondary-color]">{metric.label}</div>
								</div>
							))}
						</div>
					</div> */}

					{/* Wave Columns */}

					{waves.map((wave, i) => {
						if (i === 0) {
							return (
								<div className="flex flex-col " key={wave.wave}>
									<div
										className={`flex flex-col `}
										style={{
											borderBottom: "2px solid var(--secondary-color-2-opacity-15)",
											borderRight: "2px solid var(--secondary-color-2-opacity-15)",
										}}>
										<div className="flex justify-center">
											{/* <h3 className="text-[#5679B2] font-medium p-1 pl-4 pr-4 mb-4 text-center border  rounded-[12px]  inline-block font-semibold">{wave.wave}</h3> */}
											<span className={`${"text-[--primary-color-2] text-base-1 pr-4 pl-4"}  pl-1 pr-1 text-center inline-block font-semibold invisible`}>
												{i === waves?.length - 1 ? wave?.wave : ""}
											</span>
											<div
												className={`${
													i === waves?.length - 1 ? "text-[--primary-color-2] text-[10.5px] pr-4 pl-2 mb-4" : "text-[#5679B2] text-base-1 pr-4 pl-4 mb-4"
												}  p-1  text-center border  rounded-[12px]  inline-block font-semibold invisible`}>
												{i === waves?.length - 1 ? "Latest" : wave?.wave}
											</div>
										</div>
										<div
											className="space-y-8 p-2 pb-6"
											style={{
												background: i === waves?.length - 1 ? "linear-gradient(0deg, var(--border-or-bg-color) 0%, #FFFFFF 100%)" : "",
												borderColor: i === waves?.length - 1 ? "var(--border-or-bg-color)" : "",
											}}>
											{metrics.map((metric) => (
												<div key={metric.label} className="flex pl-6 pr-6">
													<div className="flex-1 space-y-1">
														{selectedProducts.map((product, i) => (
															<div className="flex items-center space-x-2 " key={product.name}>
																<span
																	className="font-open-sans font-normal text-base-1 align-middle text-[--secondary-color]
">
																	{i === 0 ? metric?.label : ""}
																</span>
																<div className="relative h-1 rounded flex-1 bg-gray-100 overflow-hidden invisible">
																	{/* Dashed Background */}
																	<div className="absolute inset-0 h-[1px] bg-[repeating-linear-gradient(90deg,#63646B_0px,#63646B_4px,transparent_4px,transparent_8px)] invisible"></div>

																	{/* Filled Solid Portion */}
																	<div
																		className={`absolute h-full rounded ${product.color} invisible`}
																		style={{
																			width: `${wave.metrics[metric.label.toLowerCase()][product.name]}%`,
																			backgroundColor: product.color,
																			zIndex: 1,
																		}}
																	/>
																</div>
																<span className={`font-semibold text-[${product.color}] invisible`} style={{ color: product.color }}>
																	{wave.metrics[metric.label.toLowerCase()][product.name]}%
																</span>
															</div>
														))}
													</div>
												</div>
											))}
										</div>
									</div>
									<div className="text-base-12 p-4 text-center  text-[#5679B2] font-semibold">{wave.sampleSize}</div>
								</div>
							);
						}
						return (
							<div className="flex flex-col " key={wave.wave}>
								<div
									className={`flex flex-col `}
									style={{
										borderBottom: "2px solid var(--secondary-color-2-opacity-15)",
										borderRight: "2px dashed var(--secondary-color-2-opacity-15)",
									}}>
									<div className="flex justify-center">
										{/* <h3 className="text-[#5679B2] font-medium p-1 pl-4 pr-4 mb-4 text-center border  rounded-[12px]  inline-block font-semibold">{wave.wave}</h3> */}
										<span className={`${"text-[--primary-color-2] text-base-1 pr-4 pl-4"}  pl-1 pr-1 text-center inline-block font-semibold`}>
											{i === waves?.length - 1 ? wave?.wave : ""}
										</span>
										<div
											className={`${
												i === waves?.length - 1 ? "text-[--primary-color-2] text-[10.5px] pr-4 pl-2 mb-4" : "text-[#5679B2] text-base-1 pr-4 pl-4 mb-4"
											}  p-1  text-center border  rounded-[12px]  inline-block font-semibold`}>
											{i === waves?.length - 1 ? <span className="-mb-4">Latest</span> : wave?.wave}
										</div>
									</div>
									<div
										className="space-y-8 p-2 pb-6"
										style={{
											background: i === waves?.length - 1 ? "linear-gradient(0deg,var(--border-or-bg-color) 0%, #FFFFFF 100%)" : "",
											borderColor: i === waves?.length - 1 ? "var(--border-or-bg-color)" : "",
										}}>
										{metrics.map((metric) => (
											<div key={metric.label} className="flex pl-6 pr-6">
												<div className="flex-1 space-y-1">
													{selectedProducts.map((product) => (
														<div className="flex items-center space-x-2 " key={product.name}>
															<div className="relative h-1 rounded flex-1 bg-gray-100 overflow-hidden">
																{/* Dashed Background */}
																<div className="absolute inset-0 h-[1px] bg-[repeating-linear-gradient(90deg,#63646B_0px,#63646B_4px,transparent_4px,transparent_8px)]"></div>

																{/* Filled Solid Portion */}
																<div
																	className={`absolute h-full rounded ${product.color}`}
																	style={{
																		width: `${wave.metrics[metric.label.toLowerCase()][product.name]}%`,
																		backgroundColor: product.color,
																		zIndex: 1,
																	}}
																/>
															</div>
															<span className={`font-semibold text-[${product.color}]`} style={{ color: product.color }}>
																{wave.metrics[metric.label.toLowerCase()][product.name]}%
															</span>
														</div>
													))}
												</div>
											</div>
										))}
									</div>
								</div>
								<div className="text-base-12 p-4 text-center  text-[#5679B2] font-semibold">{wave.sampleSize}</div>
							</div>
						);
					})}
				</div>

				<div className="flex bg-[#f6fbfa] rounded-lg border-2 border-dashed border-[#d1ede3] p-4">
					<span className="flex items-center justify-center pt-1">
						<img src={String(ZSLogo)} alt="ZS Logo" className="m-2" style={{ maxWidth: "2.5rem" }} />
					</span>
					<p className="mt-2 font-sans text-[14px] leading-[23px] tracking-[0.3px] ">{data?.footnote?.other_considerations}</p>
				</div>
			</div>
		</div>
	);
};

export default CustomeMetrics;
